import { lang } from '../../assets/lang'

export const userInputFlowHtml = 
'<div class="form-group text-left mt-2 pb-3">' +
  '<label for="user-input-flow-list">' + lang.user_input_flow_html_label_flow + '</label>' +
  '<select id="user-input-flow-list" class="form-control select2">' +
  '</select>' +
'</div>' +

'<div id="user-input-flow-fields" class="text-left d-none">' +
  '<div class="form-group">' +
    '<label for="campaign-name">' + lang.user_input_flow_html_label_campaign + '</label>' +
    '<input name="campaign-name" id="campaign-name" value="" class="form-control" type="text">' +
  '</div>' +
'</div>'